/**
 * 汇报流 query 层统一超时（fe-spec §2.4：摘要条 3s / 开场页成组 3s）。
 *
 * adapter 边界不带 abort 语义（mock 即时 resolve；真实接口就绪后在装配层接 signal），
 * 超时由 query 层以 race 实现 —— 超时即 reject，消费方按「失败」分支处理
 * （摘要条整条不渲染 / 开场页转页内错误态）。
 */
export function raceTimeoutMs<T>(
  promise: Promise<T>,
  timeoutMs: number,
  label: string,
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error(`${label} timed out after ${timeoutMs}ms`));
    }, timeoutMs);
    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (error: unknown) => {
        clearTimeout(timer);
        reject(error instanceof Error ? error : new Error(String(error)));
      },
    );
  });
}
